import { DefaultValues, holidayDefaultValues } from './defaultValues'
import { HolidaysByCountry, IFilterFieldDropDownData, IFilterFields } from './interface.js'

export const useState = (): FilterState => {
  return {
    filterFields: new DefaultValues(),
    filterFieldDropDownData: {
      campaigns: [],
      regions: [],
      ports: [],
      airports: [],
      ships: [],
      categories: [],
      priceModels: [],
      cruiseAttributes: [],
      hasFlexFlight: false,
      hasHigherFlightClasses: false,
      isStartPort: false,
      isEndPort: false,
    },
    holidaysByCountry: holidayDefaultValues,
    holidayError: false
  }
}

export interface FilterState {
  filterFields: IFilterFields,
  filterFieldDropDownData: IFilterFieldDropDownData,
  holidaysByCountry: HolidaysByCountry
  holidayError: boolean
}
